module.exports = __webpack_public_path__ + "assets/mic.edeb9e9a.svg";